// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const MicrophoneOn = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M20,26.91a7.55,7.55,0,0,1-7.54-7.54V11.54a7.54,7.54,0,1,1,15.08,0v7.82A7.55,7.55,0,0,1,20,26.91ZM20,5a6.55,6.55,0,0,0-6.54,6.54v7.82a6.54,6.54,0,1,0,13.08,0V11.54A6.55,6.55,0,0,0,20,5Z" />
            <Path d="M20,29.63c-9.09,0-10.14-5.55-10.14-9.72a.5.5,0,1,1,1,0c0,6.11,2.73,8.72,9.14,8.72s9.14-2.61,9.14-8.72a.5.5,0,0,1,1,0C30.14,24.08,29.09,29.63,20,29.63Z" />
            <Path d="M27.23,36H12.77a.5.5,0,1,1,0-1H27.23a.5.5,0,1,1,0,1Z" />
            <Path d="M20,36a.5.5,0,0,1-.5-.5V29.13a.5.5,0,0,1,1,0v6.33A.5.5,0,0,1,20,36Z" />
        </G>
    );
};

export default MicrophoneOn;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/microphone-on/index.js